import {EinzelBuchung} from "../app/types";

export const dbPaths = {
  createSecureKey(key) {
    // remove the following characters: '.', '#', '$', '[', ']'
    return key.split('/').join('')
      .split('\\').join('')
      .split('.').join('')
      .split('#').join('')
      .split('$').join('')
      .split('[').join('')
      .split(']').join('')
      ;
  },
  buchung(buchung?: EinzelBuchung | string, field?: string): string {
    let path = `/buchungen`;
    if(buchung) {
      const buchungKey = buchung instanceof EinzelBuchung ? buchung.$key : buchung;
      path += `/${buchungKey}`;
    }
    if(field) {
      path += `/${field}`;
    }
    return path;
  },
  logs(): string {
    return '/logs';
  },
  reise(reiseKey?: string, field?: string): string {
    let path = `/public/reisen`;
    if(reiseKey) {
      path += `/${reiseKey}`;
    }
    if(field) {
      path += `/${field}`;
    }
    return path;
  },
  capacity(key?: string, field?: string): string {
    let path = `/public/capacity`;
    if(key) {
      path += `/${key}`;
    }
    if(field) {
      path += `/${field}`;
    }
    return path;
  },
  capacityDirty(): string {
    return '/flags/capacityDirty';
  },
  // TODO rename to users
  user(userUid?: string, field?: string): string {
    let path = `/users`;
    if(userUid) {
      path += `/${userUid}`;
    }
    if(field) {
      path += `/${field}`;
    }
    return path;
  },
  userBuchungen(userUid: string, buchungKey?: string, field?: string): string {
    let path = `/users/${userUid}/buchungen`;
    if(buchungKey) {
      path += `/${buchungKey}`;
    }
    if(field) {
      path += `/${field}`;
    }
    return path;
  },
  userGuthaben(userUid: string): string {
    let path = `/users/${userUid}/guthaben`;
    return path;
  },
  stammdaten(userUid: string, field?: string): string {
    let path = `/users/${userUid}/stammdaten`;
    if(field) {
      path += `/${field}`;
    }
    return path;
  },
  teilnehmer(userUid: string, field?: string): string {
    let path = `/users/${userUid}/weitereTeilnehmer`;
    if(field) {
      path += `/${field}`;
    }
    return path;
  },
  zahlungen(userUid: string, key?: string): string {
    let path = `/users/${userUid}/zahlungen`;
    if(key) {
      path += `/${key}`;
    }
    return path;
  },
  zahlungenLastId(userUid: string): string {
    return `/users/${userUid}/zahlungenLastId`;
  }
};
